// extracted by mini-css-extract-plugin
export default {"menu-color":"rgba(255,255,255,.95)","menu-color-active":"rgba(255,255,255,.95)","menu-background":"#282c34"};